import { render, staticRenderFns } from "./view-project.vue?vue&type=template&id=c39cb2be&scoped=true"
import script from "./view-project.vue?vue&type=script&lang=js"
export * from "./view-project.vue?vue&type=script&lang=js"
import style0 from "./view-project.vue?vue&type=style&index=0&id=c39cb2be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39cb2be",
  null
  
)

export default component.exports